// NewCategory.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported

const NewAdmin = () => {
  const [name, setName] = useState('');
  const [NameAr, setNameAr] = useState('');
  const [Password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();




  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
    if (!name) {
      toast.error('Please enter  name.');
      return;
    }
    if (!NameAr) {
      toast.error('Please enter email');
      return;
    }
    if (!Password) {
      toast.error('Please enter password.');
      return;
    }
  
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
    
      const formData = new FormData();
      formData.append('name',name);
      formData.append('email',NameAr);
      formData.append('password',Password);
      console.log("formData",formData)
      const response = await fetch(baseUrl + '/create-admin', {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json', // Set Content-Type to application/json
          'Accept': 'application/json',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      const data = await response.json();
      console.log("data",data)
      if (response.ok) {
        toast.success('added successfully');
        navigate('/');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
          if (data.errors.email) {
            toast.error(data.errors.email[0]);
          }
          if (data.errors.password) {
            toast.error(data.errors.password[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

 
  return (
    <div style={{ width: '100%' }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}


      <h2 style={{ color: "#000", textAlign: 'center' }}>New Admin</h2>
      <div className="new-category-container">
        <div className="new-category">
          <div className="new-form-group">
            <label htmlFor="name">Name</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
              placeholder='Name'
              required
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="name">Email</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
              placeholder='Email'
              required
              type="text"
              id="namear"
              value={NameAr}
              onChange={(e) => setNameAr(e.target.value)}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="name">Password</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
              placeholder='Password'
              required
              type="text"
              id="Password"
              value={Password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Brand')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default NewAdmin;
